import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Product from "../customer/Components/Product/Product/Product";
import Homepage from "../Pages/Homepage";
import Navigation from "../customer/Components/Navbar/Navigation";
import Footer from "../customer/Components/footer/Footer";
import About from "../Pages/About";
import Contact from "../Pages/Contact";
import ProductDetails from "../customer/Components/Product/ProductDetails/ProductDetails";
import HelpCenter from "../customer/Components/Helpcenter/HelpCenter";
import Profile from "../Pages/Profile/Component/Profile";
import SeachProduct from "../Pages/SeachProduct";
import Cart from "../customer/Components/Cart/Cart";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import RateProduct from "../customer/Components/ReviewProduct/RateProduct";
import TearmsCondition from "../Pages/TearmsCondition";
import OrderDetails from "../Pages/OrderDetails/OrderDetails";
import Checkout from "../customer/Components/Checkout/Checkout";
import PaymentSuccess from "../customer/Components/paymentSuccess/PaymentSuccess";
// import OrderDetails from "../Pages/OrderDetails/OrderDetails";

const CustomerRoutes = () => {
  const location = useLocation();

  // Only show Navigation component when not on the NotFound page
  const showNavigation = location.pathname !== "*";
  return (
    <div>
      {showNavigation && <Navigation />}
      <Routes>
        <Route path="/" element={<Homepage />}></Route>
        <Route
          path="/:lavelOne/:lavelTwo/:lavelThree"
          element={<Product />}
        ></Route>
        <Route path="/product/:productId" element={<ProductDetails />}></Route>
        <Route path="/" element={<Homepage />}></Route>
        <Route path="/home" element={<Homepage />}></Route>
        <Route path="/privaciy-policy" element={<PrivacyPolicy />}></Route>
        <Route path="/terms-condition" element={<TearmsCondition />}></Route>
        <Route path="/help-center" element={<HelpCenter />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/account/profile" element={<Profile />}></Route>
        <Route path="/search/*" element={<SeachProduct />}></Route>
        <Route path="/cart" element={<Cart />}></Route>
        <Route
          path="/account/rate/:productId"
          element={<RateProduct />}
        ></Route>
        <Route path="/order/detail/:orderId" element={<OrderDetails />}></Route>
        <Route path="/checkout" element={<Checkout />}></Route>
        <Route path="/admin/orderDetail/:orderId" element={<OrderDetails />} />
        <Route path="/payment/:orderId" element={<PaymentSuccess />}></Route>
        {/* <Route path="/payment/:orderId" element={<OrderDetails />}></Route> */}
      </Routes>
      <Footer />
    </div>
  );
};

export default CustomerRoutes;
